import React from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ServiePage = () => {
  return (
    <>
      {" "}
      <main className="bg-color">
        <Header />
        <section className="heading-section">
          <p className=" font_54 text-white font_500 text-center">Services</p>
        </section>
        <SectionWrpper className="mb-5">
          <div className="container">
            <div className="terms-use p-0 overflow-hidden mb-4">
              <div className="row g-0">
                <div className="col-lg-4">
                  <div className="about-banner imgWrpper">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/Frame 48096442.png"
                      }
                      alt="image"
                    />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="details-about">
                    {/* <p className="font_20 font_500 mb-0">INTRODUCTION</p> */}
                    <div>
                      <p className="font_15">
                        Monte Sereno Health (MSH) is rolling out a Multi-Agent
                        One-Stop B2B2C Healthcare platform, containing the
                        entire healthcare ecosystem in each geography it serves.
                        We are working to transform African healthcare using AI
                        to overcome infrastructure deficits.
                      </p>
                      <p className="font_15">
                        MSH is a membership-based platform where caregivers and
                        patients can interact, and patients can obtain seamless
                        care from online and offline providers.
                      </p>
                    </div>
                    {/* <div className="text-center">
                      <p className="font_20 text-blue">
                        Please Sign Up and Login to Access Our Services
                      </p>
                    </div> */}
                    <div>
                      <Link
                        className="d-flex justify-content-center"
                        style={{
                          backgroundColor: "#fc7c37",
                          color: "white",
                          padding: "5px",
                          textAlign: "center",
                          marginTop: "16px",
                          margin: 0,
                          fontSize: "20px",
                        }}
                        to="/signup"
                      >
                        Please Sign Up and Login to Access Our Services
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SectionWrpper>
        <Footer />
      </main>
    </>
  );
};

const SectionWrpper = styled.div`
  @media (max-width: 991px) {
    .imgWrpper {
      display: block !important;
      img {
        height: auto;
        object-fit: contain;
      }
    }
  }
`;

export default ServiePage;
